import { isFeatureEnabled } from '@lumapps/features';

import { BACK_OFFICE_ALPHA_FF, BACK_OFFICE_BETA_FF } from '../constants';

export const isBackOfficeAlphaEnabled = isFeatureEnabled(BACK_OFFICE_ALPHA_FF);
export const isBackOfficeBetaEnabled = isFeatureEnabled(BACK_OFFICE_BETA_FF);
